import { render, staticRenderFns } from "./UploadImageModal.vue?vue&type=template&id=aa156404&scoped=true&"
import script from "./UploadImageModal.vue?vue&type=script&lang=js&"
export * from "./UploadImageModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageModal.vue?vue&type=style&index=0&id=aa156404&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa156404",
  null
  
)

export default component.exports